/**
 *
 * SimpleSearch
 *
 */

import {Component} from "react";
import * as PropTypes from "prop-types";
import styled, {css} from "styled-components";
import TextField from "basicComponents/TextField/TextField";
import SearchItem from "./SearchItem";
import {TableButton} from "../Searchv2/TableButton";

const enhanceWithClickOutside = require("react-click-outside");

function noop() {}

class SimpleSearch extends Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    onValueChanged: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
        PropTypes.object,
      ]),
    ),
    noStyling: PropTypes.bool, // Disable item styling
    maxHeight: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    selected: PropTypes.any,
    selectedIndex: PropTypes.number,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    error: PropTypes.bool,
    closable: PropTypes.bool,
    noPadding: PropTypes.bool,
    id: PropTypes.string,
    contentId: PropTypes.string,
    returnEvent: PropTypes.bool,
    useItemObject: PropTypes.bool,
    enableUglyLongButtonOnNoResult: PropTypes.bool,
    enableUglyLongButton: PropTypes.bool,
    handleUglyButtonClicked: PropTypes.func,
    noResultButtonId: PropTypes.string,
    iconButtonText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    customHeight: PropTypes.string,
    fullWidth: PropTypes.bool,
    customWidth: PropTypes.string,
    customPadding: PropTypes.number,
    customIconScale: PropTypes.number,
    className: PropTypes.string,
    isRequired: PropTypes.bool,
  };

  static defaultProps = {
    items: [],
    maxHeight: "7.6rem",
    placeholder: "",
    selected: null,
    selectedIndex: -1,
    closable: false,
    onClick: noop,
    onDoubleClick: noop,
    className: "",
  };

  state = {
    open: false,
  };

  handleClickOutside() {
    this.setState({
      open: false,
    });
  }

  handleFocus = () => {
    if (this.props.closable) {
      this.setState({
        open: true,
      });
    }
  };

  handleClick = (item, index) => {
    this.props.onClick(item, index);
    this.setState({
      open: false,
    });
  };

  handleDoubleClick = (item, index) => {
    this.props.onDoubleClick(item, index);
    this.setState({
      open: false,
    });
  };

  handleInputTextChanged = e => {
    if (this.props.returnEvent) {
      this.props.onValueChanged(e);
    } else {
      this.props.onValueChanged(e.target.value);
    }
  };

  renderItem = (item, index) => {
    if (this.props.noStyling && !this.props.useItemObject) {
      return item;
    }

    if (this.props.noStyling && this.props.useItemObject) {
      return item.name;
    }

    let key = ``;

    if (this.props.useItemObject) {
      key = `${item.name}${item.id || ""}`;
    } else {
      key = `${item}${item.key || ""}`;
    }

    return (
      <SearchItem
        item={item.name || item}
        key={key}
        id={`${key}`}
        selected={this.props.selected}
        selectedIndex={this.props.selectedIndex}
        index={index}
        onClick={this.handleClick}
        onDoubleClick={this.handleDoubleClick}
      />
    );
  };

  renderContent() {
    return (
      <ContentWrapper maxHeight={this.props.maxHeight}>
        <Content
          maxHeight={this.props.maxHeight}
          id={this.props.contentId}
          data-cy="dropdownContent"
        >
          {this.props.items.map(this.renderItem)}
        </Content>
      </ContentWrapper>
    );
  }

  // Button Added for adding new DENTIST!!!! can be shown with enableUglyLongButtonOnNoResult
  renderClosableContent() {
    const buttonVisible = this.isButtonVisible();

    if (!this.state.open) {
      return null;
    }
    return (
      <ClosableContentWrapper maxHeight={this.props.maxHeight} open={!this.props.items || this.props.items.length > 0}>
        <Content
          maxHeight={this.props.maxHeight}
          id={this.props.contentId}
          data-cy="dropdownItems"
        >
          {buttonVisible && (
            <TableButton
              customIconScale={this.props.customIconScale}
              customPadding={this.props.customPadding}
              customHeight={this.props.customHeight}
              customWidth={this.props.customWidth}
              fullWidth={this.props.fullWidth}
              noResultButtonId={this.props.noResultButtonId}
              iconButtonText={this.props.iconButtonText}
              onClick={this.props.handleUglyButtonClicked}
            />
          )}
          {this.props.items.map(this.renderItem)}
        </Content>
      </ClosableContentWrapper>
    );
  }

  // For handling button of dentist
  isButtonVisible() {
    if (this.props.enableUglyLongButton) {
      return true;
    }

    if (this.props.enableUglyLongButtonOnNoResult) {
      return (
        this.props.items &&
        this.props.items.length === 0 &&
        !this.props.loading &&
        (this.props.value || "").length > 2
      );
    }
    return false;
  }

  render() {
    let value = this.props.value;
    if (
      this.props.closable &&
      !this.state.open &&
      this.props.selectedIndex !== -1
    ) {
      value = this.props.items[this.props.selectedIndex];
    }

    return (
      <Wrapper
        className={this.props.className}
        closable={this.props.closable}
        maxHeight={this.props.maxHeight}
        open={this.state.open && this.props.items && this.props.items.length > 0}
      >
        <TextFieldWrapper>
          <TextField
            id={this.props.id}
            noPadding={this.props.noPadding}
            onFocus={this.handleFocus}
            error={this.props.error}
            placeholder={this.props.placeholder}
            onChange={this.handleInputTextChanged}
            value={value}
            autoComplete="off"
            autoCorrect="off"
            disabled={this.props.disabled}
            required={this.props.isRequired}
          />
        </TextFieldWrapper>
        {this.props.closable
          ? this.renderClosableContent()
          : this.renderContent()}
      </Wrapper>
    );
  }
}

export default enhanceWithClickOutside(SimpleSearch);

const Content = styled.div`
  max-height: ${({ maxHeight }) => maxHeight};
  overflow-y: auto;
`;

const ClosableContentWrapper = styled.div`
  left: -1px;
  z-index: 99999;
  width: 100%;
  box-sizing: content-box;
  background-color: white;
  position: absolute;
  max-height: ${({ maxHeight }) => maxHeight};
  overflow: hidden;
  border-left: solid 1px ${({ theme }) => theme.borderColor};
  border-right: solid 1px ${({ theme }) => theme.borderColor};
  border-bottom: solid ${({open})=> open ? '1px' : '0px'} ${({ theme }) => theme.borderColor};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
`;

const ContentWrapper = styled.div`
  max-height: ${({ maxHeight }) => maxHeight};
  overflow: hidden;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  position: relative;
`;

const TextFieldWrapper = styled.div`
  width: calc(100% + 2px);
  margin-left: -1px;
`;

function border({ closable, open, theme }) {
  if (closable && !open) {
    return css`
      border: 1px solid ${theme.borderColor};
      border-top: none;
      border-bottom: none;
    `;
  }

  return css`
    border: 1px solid ${theme.borderColor};
    border-top: none;
  `;
}
function borderRadius({ closable, open, theme }) {
  if (closable && open) {
    return css`
      border-radius: 0;
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
    `;
  }
  return css`
    border-radius: 25px;
  `;
}

const Wrapper = styled.div`
  position: relative;
  ${borderRadius} ${border};
`;
